import React from 'react';
import { motion } from 'framer-motion';
import { faqs } from '../data/mockData';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from './ui/accordion';

const FAQSection = () => {
  return (
    <section id="faq" data-testid="faq-section" className="py-28 relative">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-12 gap-16">
          <motion.div className="lg:col-span-4" initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}>
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#3B82F6]/10 border border-[#3B82F6]/20 mb-5">
              <span className="text-xs font-semibold text-[#3B82F6] uppercase tracking-wider">FAQ</span>
            </div>
            <h2 className="font-heading text-4xl sm:text-5xl font-semibold tracking-tight text-white mb-5">
              Common <span className="text-gradient">Questions</span>
            </h2>
            <p className="text-[#A1A1AA] leading-relaxed">
              Everything you need to know about logo trademark registration and protection.
            </p>
          </motion.div>

          <div className="lg:col-span-8">
            <Accordion type="single" collapsible>
              {faqs.map((faq) => (
                <AccordionItem key={faq.id} value={`item-${faq.id}`} className="border-b border-white/[0.06] px-0">
                  <AccordionTrigger className="text-left text-sm font-semibold text-white hover:text-[#3B82F6] py-5 hover:no-underline faq-trigger">
                    {faq.question}
                  </AccordionTrigger>
                  <AccordionContent className="text-[#A1A1AA] leading-relaxed pb-5 text-sm">
                    {faq.answer}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
